import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail, MessageCircle, Smartphone } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide03Background({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-69">
      <SlideHeader eyebrow="Current Situation" data-id="element-70">
        Amoxil is digital-first, but the format needs to work harder
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-71">
        {/* Left text content */}
        <div className="flex-1 space-y-8" data-id="element-72">
          {['Amoxil is promoted 100% digitally.', 'GSK Morocco already uses digital channels such as email and WhatsApp.', 'Current assets are well-designed, but HCP engagement is declining.', 'The next opportunity is not simply more content, but a more engaging format.'].map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + i * 0.15,
          duration: 0.5
        }} className="flex items-start gap-4" data-id="element-73">
              <div className="mt-1.5 h-2 w-2 rounded-full bg-[var(--brand)] flex-shrink-0" data-id="element-74" />
              <p className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--fg)] font-medium leading-relaxed" data-id="element-75">
                {point}
              </p>
            </motion.div>)}
        </div>

        {/* Right visual comparison */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-1 w-full bg-[var(--surface)] rounded-3xl p-8 border border-black/5 flex flex-col items-center relative" data-id="element-76">
          <div className="absolute top-4 left-4 text-xs font-bold uppercase tracking-wider text-[var(--muted)]" data-id="element-77">
            From Passive
          </div>
          <div className="absolute top-4 right-4 text-xs font-bold uppercase tracking-wider text-[var(--brand)]" data-id="element-78">
            To Interactive
          </div>

          <div className="flex items-center justify-center w-full gap-6 mt-6" data-id="element-79">
            {/* Passive side */}
            <div className="w-64" data-id="element-80">
              <img src="https://cdn.magicpatterns.com/uploads/pYRAWESiLT3ffXuSTVNxqJ/Screenshot_2026-06-29_at_12.58.39.png" alt="Passive digital format example" className="w-full h-auto rounded-xl shadow-md border border-black/10" data-id="element-81" />
            </div>

            {/* Arrow */}
            <div className="flex-shrink-0 text-[var(--brand-light)]" data-id="element-82">
              <ArrowRight className="h-8 w-8" data-id="element-83" />
            </div>

            {/* Interactive side */}
            <div className="w-48 relative" data-id="element-84">
              <div className="absolute -inset-4 bg-[var(--brand)]/10 rounded-3xl blur-xl" data-id="element-85" />
              <img src="https://cdn.magicpatterns.com/uploads/7abRhafkJdCwR9XYCAKe7C/Screenshot_2026-06-29_at_12.57.57.png" alt="Interactive Snakker format example" className="w-full h-auto rounded-[2rem] shadow-2xl border-4 border-white relative z-10" data-id="element-86" />
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}